var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBytesizeDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49982 10.2C-0.000177457 10.7 0.499823 5.20003 4.49982 5.70003C2.99982 0.200031 11.4998 0.200031 10.9998 4.20003C15.9998 2.70003 15.9998 10.7 11.4998 10.2M5.49982 12.2L7.99982 14.2M7.99982 14.2L10.4998 12.2M7.99982 14.2V7.20003",
    stroke: "#232627",
    strokeOpacity: 0.8,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBytesizeDownload);
export default __webpack_public_path__ + "static/media/bytesize_download.cec4ee8b32df73a7a8219b97aef71b42.svg";
export { ForwardRef as ReactComponent };